import { AirUrlParams } from 'hooks/useAirNavigation';

export type Type = string[];

export function create(): Type {
	return [];
}

export function mapToUrl(obj: Type): string {
	return obj.join(';');
}

export function mapFromUrl(params: AirUrlParams, urlKey: string): Type {
	if (params[urlKey]) return params[urlKey].split(';');
	return [];
}
